import { render } from "./ThePatientExpedientFile.vue?vue&type=template&id=7af77b82&scoped=true&ts=true"
import script from "./ThePatientExpedientFile.vue?vue&type=script&lang=ts"
export * from "./ThePatientExpedientFile.vue?vue&type=script&lang=ts"

import "./ThePatientExpedientFile.vue?vue&type=style&index=0&id=7af77b82&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af77b82"]])

export default __exports__